<template>
  <div class="mt-4 px-5">
    <v-alert dense text shaped type="info">
      <b>Meine Arbeitseinsätze</b>
      <div>
        Hier sehen Sie alle geplanten Arbeitseinsätze. Sie können sich zu Einsätzen an- oder abmelden.
      </div>
    </v-alert>

    <v-card class="mb-4">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-select
              v-model="selectedClub"
              :items="userClubs"
              item-text="name"
              item-value="id"
              label="Verein filtern"
              clearable
              @change="fetchData"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" class="text-right">
            <v-btn color="primary" @click="fetchData">
              <v-icon left>mdi-reload</v-icon>
              Aktualisieren
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="$store.state.UserApp.Arbeitseinsaetze"
      :loading="loading"
      sort-by="geplant_von"
      class="elevation-1"
    >
      <template v-slot:item.zeitraum="{ item }">
        {{ formatDateTime(item.geplant_von) }} - {{ formatDateTime(item.geplant_bis) }}
      </template>

      <template v-slot:item.mein_status="{ item }">
        <v-chip
          small
          :color="getStatusColor(item.mein_status)"
          dark
        >
          {{ item.mein_status || 'Nicht angemeldet' }}
        </v-chip>
      </template>

      <template v-slot:item.teilnehmer="{ item }">
        {{ item.teilnehmer_count }}{{ item.max_teilnehmer ? ' / ' + item.max_teilnehmer : '' }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="item.mein_status !== 'angemeldet'"
          small
          color="success"
          @click="toggleRegistration(item)"
          :disabled="item.max_teilnehmer && item.teilnehmer_count >= item.max_teilnehmer"
        >
          Anmelden
        </v-btn>
        <v-btn
          v-else
          small
          color="error"
          @click="toggleRegistration(item)"
        >
          Abmelden
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

export default {
  name: "UserAssignments",
  data() {
    return {
      loading: false,
      userClubs: [],
      selectedClub: null,
      headers: [
        { text: "Verein", value: "club_name" },
        { text: "Titel", value: "titel" },
        { text: "Ort", value: "ort" },
        { text: "Zeitraum", value: "zeitraum", sortable: false },
        { text: "Teilnehmer", value: "teilnehmer" },
        { text: "Mein Status", value: "mein_status" },
        { text: "Aktion", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    this.fetchClubs();
    this.fetchData();
  },
  methods: {
    async fetchClubs() {
      if (this.$store.state.UserApp.Clubs.length === 0 || !this.$store.state.UserApp.Clubs.Vereine) {
        await this.$store.dispatch("UserApp/getClubs");
      }
      
      const clubsData = this.$store.state.UserApp.Clubs;
      // Nur Vereine mit Arbeitsstunden-Berechtigung anzeigen
      const allClubs = clubsData.meineVereine || clubsData.Vereine || [];
      this.userClubs = allClubs.filter(c => (c.can && (c.can.arbeitsstunden || c.can.arbeitsstunden_full)) || c.has_arbeitsstunden || c.has_arbeitsstunden_full || c.hasArbeitsstundenAccess);

      // Fallback falls Flag fehlt
      if (this.userClubs.length === 0 && allClubs.length > 0) {
        this.userClubs = allClubs;
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const params = {};
        if (this.selectedClub) params.club_id = this.selectedClub;
        await this.$store.dispatch("UserApp/getUserArbeitseinsaetze", params);
      } catch (error) {
        console.error("Fehler beim Laden der Einsätze:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";
      const date = new Date(dateTimeStr.replace(" ", "T"));
      return date.toLocaleString([], {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getStatusColor(status) {
      switch (status) {
        case "angemeldet": return "success";
        case "abgesagt": return "error";
        case "teilgenommen": return "primary";
        default: return "grey";
      }
    },
    async toggleRegistration(item) {
      try {
        await this.$store.dispatch("UserApp/toggleUserArbeitseinsatzAnmelden", { id: item.id });
        this.fetchData();
      } catch (error) {
        console.error("Fehler bei der An/Abmeldung:", error);
      }
    },
  },
};
</script>
